import { useLPSuspenseQuery } from '../lib/hooks/useLPQuery';

export enum CampaignActionType {
  SUCCESS = 'success',
  NEUTRAL = 'neutral',
  FAIL = 'fail',
}

export enum ScoreBreakdownCategories {
  COMPLETION = 'completion',
  PHISHING_REPORTS = 'phishingReports',
  PHISHING_CLICKS = 'phishingClicks',
  ENGAGEMENT = 'engagement',
  EMAIL_SECURITY = 'emailSecurity',
  KNOWLEDGE = 'knowledge',
  DATA_PROTECTION = 'dataProtection',
  MICROSOFT_IDENTITY = 'microsoftIdentity',
}

export type AggregatedScoreBreakdown = {
  scoreBreakdown: string;
  score: number;
  globalScore: number;
  assetsUrl?: string;
};

export type CampaignAction = {
  campaignId: string;
  date: string;
  result: CampaignActionType;
};

export type ScoreBreakdownContentEntryKey =
  | 'scoreBreakdownCompletion'
  | 'scoreBreakdownEngagement'
  | 'scoreBreakdownEmailSecurity'
  | 'scoreBreakdownKnowledge'
  | 'scoreBreakdownDataProtection'
  | 'scoreBreakdownMicrosoftIdentity'
  | 'scoreBreakdownPhishingReports'
  | 'scoreBreakdownPhishingClicks';

export type DynamicActionAggregation = {
  actionScoreType: number;
  actionName: string;
  scoreBreakdown: ScoreBreakdownCategories | string;
  score: number;
  globalScore: number;
  assetsUrl: string;
  createdTime?: string;
  scoreBreakdownCategoryName?: string;
};

export type ScoreBreakdownCategoryAggregation = {
  categoryName: string;
  score: number;
  globalScore: number;
};

export type ScoreBreakdownData = {
  learnerId?: string;
  scoreBreakdownAggregations: AggregatedScoreBreakdown[];
  campaignActions: CampaignAction[];
  trainingsOnLast30Days?: boolean;
  dynamicActionAggregations?: DynamicActionAggregation[];
  scoreBreakdownCategoryAggregations?: ScoreBreakdownCategoryAggregation[];
};

export function useScoreBreakdownByUserQuery() {
  return useLPSuspenseQuery<ScoreBreakdownData>([`scoreBreakdowns/me/summary`], `/scoreBreakdowns/me/summary`);
}
